var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app"},[_c('div',[(_vm.isSearch)?_c('search',{attrs:{"id":1}}):_c('div',[_c('tab-nav'),_c('home'),_c('to-top')],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }